import dataBusUtil from './webSocketCommon/dataBusUtils/dataBusUtils.js';
import api from './api.js';
import log from './systemCommon/log.js';
let intervalId = 0;
Date.prototype.format = function(format) {
    var args = {
        'M+': this.getMonth() + 1,
        'd+': this.getDate(),
        'h+': this.getHours(),
        'm+': this.getMinutes(),
        's+': this.getSeconds(),
        'q+': Math.floor((this.getMonth() + 3) / 3), //quarter
        S: this.getMilliseconds()
    };
    if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
    for (var i in args) {
        var n = args[i];
        if (new RegExp('(' + i + ')').test(format)) format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? n : ('00' + n).substr(('' + n).length));
    }
    return format;
};
export default {
    beginMQSend() {
        let first = {
            authType: 'online',
            businessData: {
                userId: sessionStorage.getItem('userId'),
                ip: sessionStorage.getItem('ip'),
                clientType: 'PC',
                time: new Date().format('yyyy-MM-dd hh:mm:ss')
            },
            moduleId: 'TdWebMain',
            operationLogVo: null,
            resType: 'sys',
            routingKey: 'PG.com.tiandy.pangu.framework.authorityserver.sys.online',
            sysId: 'PG',
            token: sessionStorage.getItem('token')
        };
        if (sessionStorage.getItem('ip')) {
            dataBusUtil.sendMsgByRoutingKey('onlineUsersTopic_product', 'PG.com.tiandy.pangu.framework.authorityserver.sys.online', first);
        }
        let param = {
            id: 'onlineTime'
        };
        api.querySystemInfoByPlatformFlg(param, response => {
            let platformInfo = response.data.content[0];
            let onlineTime = 180000;
            if (platformInfo.params) {
                this.platformTitle = JSON.parse(platformInfo.params);
                onlineTime = this.platformTitle.onlineTime;
            }
            intervalId = window.setInterval(
                function() {
                    let msg = {
                        authType: 'online',
                        businessData: {
                            userId: sessionStorage.getItem('userId'),
                            ip: sessionStorage.getItem('ip'),
                            clientType: 'PC',
                            time: new Date().format('yyyy-MM-dd hh:mm:ss')
                        },
                        moduleId: 'TdWebMain',
                        operationLogVo: null,
                        resType: 'sys',
                        routingKey: 'PG.com.tiandy.pangu.framework.authorityserver.sys.online',
                        sysId: 'PG',
                        token: sessionStorage.getItem('token')
                    };
                    if (sessionStorage.getItem('ip')) {
                        dataBusUtil.sendMsgByRoutingKey('onlineUsersTopic_product', 'PG.com.tiandy.pangu.framework.authorityserver.sys.online', msg);
                    }
                },
                onlineTime ? onlineTime : 180000
            );
        });
    },
    endMQSend() {
        if (0 != intervalId) {
            window.clearInterval(intervalId);
        }
    }
};
